import React from 'react';
import dot from 'dot-object';
import { Helmet } from 'react-helmet';

import { Brand } from '@ttstr/api/products';
import { useShopConfig } from '@ttstr/components';

interface Props {
  brand: Brand;
}

/**
 * Dokumentation from https://schema.org/MusicGroup
 */

interface BrandSchema {
  '@context': 'https://schema.org';
  '@type': 'MusicGroup';
  name: string;
  description: string;
  image?: string;
}

const BrandMarkup: React.FC<Props> = ({ brand }) => {
  const { canonicalUrl } = useShopConfig();

  const jsonLd: Partial<BrandSchema> = {
    '@context': 'https://schema.org',
    '@type': 'MusicGroup',
  };

  dot.copy('title', 'name', brand, jsonLd);
  dot.copy('description', 'description', brand, jsonLd);
  jsonLd.image = brand.image ? canonicalUrl + brand.image.url : '';

  return (
    <Helmet>
      <title>{brand.title}</title>
      <script type="application/ld+json">{`${JSON.stringify(jsonLd)}`}</script>
    </Helmet>
  )
}

export default React.memo(BrandMarkup);
